import { DEFAULT_DRIVING_COURSE_ID } from '../data/courseOptions';
import { DEFAULT_TIME_OF_DAY_ID } from '../data/timeOfDayOptions';
import {
  DEFAULT_DRIVING_CAMERA_MODE,
  type DrivingCameraMode,
} from '../data/drivingCameraOptions';
import {
  DEFAULT_DRIVING_CHALLENGE_ID,
  type DrivingChallengeId,
} from '../data/challengeOptions';
import {
  DEFAULT_VEHICLE_TUNING,
  type VehicleTuning,
} from './vehicleTuning';

export interface DrivingAssists {
  abs: boolean;
  tcs: boolean;
  esc: boolean;
}

export type DrivingAssistId = keyof DrivingAssists;
export type WeatherMode = 'fixed' | 'dynamic';

/**
 * 가속 페달을 놓았을 때 전기차가 만드는 감속 단계입니다.
 * 내연기관/PHEV에서는 저장은 유지하되 물리에 적용하지 않습니다.
 */
export type RegenMode = 'standard' | 'strong' | 'one-pedal';

export const REGEN_MODES: readonly RegenMode[] = ['standard', 'strong', 'one-pedal'];
export const DEFAULT_REGEN_MODE: RegenMode = 'standard';

export function isRegenMode(value: unknown): value is RegenMode {
  return typeof value === 'string' && REGEN_MODES.includes(value as RegenMode);
}

export interface DrivingPreferences {
  courseId: string;
  timeOfDayId: string;
  cameraMode: DrivingCameraMode;
  weatherMode: WeatherMode;
  challengeId: DrivingChallengeId;
  regenMode: RegenMode;
  assists: DrivingAssists;
  tuning: VehicleTuning;
}

export const DEFAULT_DRIVING_ASSISTS: Readonly<DrivingAssists> = Object.freeze({
  abs: true,
  tcs: true,
  esc: true,
});

export function createDefaultDrivingPreferences(): DrivingPreferences {
  return {
    courseId: DEFAULT_DRIVING_COURSE_ID,
    timeOfDayId: DEFAULT_TIME_OF_DAY_ID,
    cameraMode: DEFAULT_DRIVING_CAMERA_MODE,
    weatherMode: 'fixed',
    challengeId: DEFAULT_DRIVING_CHALLENGE_ID,
    regenMode: DEFAULT_REGEN_MODE,
    assists: { ...DEFAULT_DRIVING_ASSISTS },
    tuning: { ...DEFAULT_VEHICLE_TUNING },
  };
}
